import React from "react";
import SelectInput from "../widgets/SelectInput";
import getLezioniCorso from "../services/getLezioniCorso";
import getCorsi from "../services/getCorsi";
import Cookies from "universal-cookie";
import FixButton from "./Button";
import addPropostaRecupero from "../services/addPropostaRecupero";
import moment from "moment";
import "moment/locale/it";

export default class PropostaRecuperoLezione extends React.Component {
  constructor(props) {
    super(props);

    // Configura moment.js per l'italiano
    moment.locale("it");

    this.state = {
      corsiPerRecupero: [],
      lezioni: [], // Lezioni già espanse dal backend (include sessioni)
      selectedLezione: null,
      selectedCorso: null,
      noteRecupero: "", // Nuovo campo per le note
      isSaving: false,
      isLoadingLezioni: false, // Indicatore di caricamento
    };
  }

  componentDidMount() {
    this.reload();
  }

  reload() {
    this.getCorsiForRecupero();
  }

  getCorsiForRecupero() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const corsoId = cookies.get("currentCourse", { path: "/" });

    getCorsi(username, token)
      .then((corsi) => {
        const corso = corsi.find((c) => Number(c.id) === Number(corsoId));
        if (corso) {
          this.setState({
            corsiPerRecupero: corsi.filter(
              (c) => Number(c.id_categoria) === Number(corso.id_categoria)
            ),
          });
        } else {
          throw new Error("Corso non trovato");
        }
      })
      .catch((error) => {
        console.error("Error fetching corsi:", error);
      });
  }

  async getLezioniForCorso(corsoId) {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    this.setState({ isLoadingLezioni: true });

    try {
      // Il backend getLezioniCorso.php restituisce già le lezioni espanse con le sessioni
      const lezioni = await getLezioniCorso(username, token, corsoId);
      console.log(
        "[PropostaRecupero] Lezioni dal backend (già espanse):",
        lezioni
      );

      this.setState({ lezioni, isLoadingLezioni: false });
    } catch (error) {
      console.error("Error fetching lezioni:", error);
      this.setState({ isLoadingLezioni: false });
    }
  }

  async addProposta() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    const idRichiestaRecupero = this.props.id_recupero_lezione;
    const idSessioneAssenza = this.props.id_sessione; // id_sessione dell'assenza originale

    try {
      this.setState({ isSaving: true });

      // Estrai id_lezione e id_sessione dalla selezione
      const idLezioneRecupero = this.state.selectedLezione.id_lezione;
      const idSessioneRecupero = this.state.selectedLezione.id_sessione; // id_sessione per il recupero

      // Log delle informazioni sulla proposta di recupero
      const dataLezione = this.state.selectedLezione.label;
      const corsoLabel = this.state.selectedCorso.label;

      console.log("Data lezione proposta:", dataLezione, "Corso:", corsoLabel);
      console.log(
        "[PropostaRecuperoLezione] id_lezione recupero:",
        idLezioneRecupero
      );
      console.log(
        "[PropostaRecuperoLezione] id_sessione recupero:",
        idSessioneRecupero
      );
      console.log(
        "[PropostaRecuperoLezione] id_sessione assenza:",
        idSessioneAssenza
      );

      const resp = await addPropostaRecupero(
        username,
        token,
        this.state.selectedCorso.value,
        this.state.selectedCorso.label,
        idLezioneRecupero, // Passa solo l'id_lezione
        this.state.selectedLezione.label,
        idRichiestaRecupero,
        this.state.noteRecupero,
        idSessioneAssenza, // id_sessione dell'assenza originale
        idSessioneRecupero // id_sessione per il recupero
      );

      if (resp && resp.result === "ok") {
        alert("Recupero inserito con successo!");

        if (this.props.reloadRecupero) {
          this.props.reloadRecupero();
        }
      } else {
        alert("Errore nell'inserimento del recupero");
      }
    } catch (err) {
      console.error("Errore:", err);
      alert("Errore durante il salvataggio del recupero");
    } finally {
      this.setState({ isSaving: false });
      this.props.onClose();
    }
  }

  render() {
    console.log("lezione:", this.state.selectedLezione);
    console.log("corso", this.state.selectedCorso);
    return (
      <div style={cardClass}>
        <div
          style={closeIcon}
          onClick={() => {
            this.props.onClose();
          }}
        >
          X
        </div>
        <div className="windowTitle" style={{ color: "black" }}>
          Proponi recupero
        </div>
        <div style={{ marginTop: "10px", textAlign: "center" }}>
          {(this.props.studente?.cognome || "") +
            " " +
            (this.props.studente?.nome || "")}
        </div>
        <SelectInput
          style={{ marginTop: "20px" }}
          options={
            this.state.corsiPerRecupero.map((c) => ({
              value: c.id,
              label: c.name,
            })) ?? []
          }
          onChange={(val) => {
            this.setState({ selectedCorso: val });
            this.getLezioniForCorso(val.value);
          }}
          value={this.state.selectedCorso}
          placeholder="Seleziona un corso"
        />{" "}
        {this.state.isLoadingLezioni ? (
          <div
            style={{ marginTop: "20px", textAlign: "center", color: "#666" }}
          >
            ⏳ Caricamento lezioni...
          </div>
        ) : null}
        {this.state.selectedCorso && !this.state.isLoadingLezioni ? (
          <SelectInput
            style={{ marginTop: "20px" }}
            options={(this.state.lezioni || []).map((l) => {
              console.log("[PropostaRecupero] Dati lezione dal backend:", l);

              // Formatta la data
              let formattedDate = "";
              let oraFormatted = "";

              if (l.data) {
                const dataMoment = moment(l.data);
                formattedDate = dataMoment.format("DD/MM/YYYY");

                // Usa l'orario della sessione se disponibile (dal backend)
                if (l.is_sessione && l.sessione_ora_inizio) {
                  // Rimuovi i secondi dall'orario (da HH:mm:ss a HH:mm)
                  const oraSenzaSecondi = l.sessione_ora_inizio.substring(0, 5);
                  oraFormatted = ` ore ${oraSenzaSecondi}`;
                } else if (l.ora_inizio) {
                  // Fallback all'ora della lezione principale, rimuovi i secondi
                  const oraSenzaSecondi = l.ora_inizio.substring(0, 5);
                  oraFormatted = ` ore ${oraSenzaSecondi}`;
                }
              }

              // Materia (già fornita dal backend per sessione)
              const materia = l.str_materia ? ` - ${l.str_materia}` : "";

              // Label sessione (già fornita dal backend)
              const sessioneLabel =
                l.is_sessione && l.label_sessione
                  ? ` - ${l.label_sessione}`
                  : "";

              // Il value deve includere l'id_sessione se presente
              const valueObj = l.is_sessione
                ? `${l.id}_${l.id_sessione}`
                : l.id;

              return {
                value: valueObj,
                label: `${formattedDate}${oraFormatted}${materia}${sessioneLabel}`,
                id_lezione: l.id,
                id_sessione: l.id_sessione || null,
                is_sessione: l.is_sessione,
              };
            })}
            onChange={(val) => {
              this.setState({ selectedLezione: val });
            }}
            value={this.state.selectedLezione}
            placeholder="Seleziona una lezione"
          />
        ) : null}
        {/* Campo Note per il recupero */}
        <div style={{ marginTop: "20px" }}>
          <label
            style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "8px",
            }}
          >
            Note (opzionale):
          </label>
          <textarea
            value={this.state.noteRecupero}
            onChange={(e) => {
              this.setState({ noteRecupero: e.target.value });
            }}
            placeholder="Inserisci eventuali note per questo recupero..."
            style={{
              width: "100%",
              minHeight: "80px",
              padding: "8px 12px",
              border: "1px solid #ddd",
              borderRadius: "4px",
              fontSize: "14px",
              resize: "vertical",
              fontFamily: "inherit",
            }}
            maxLength={500}
          />
          <div
            style={{
              fontSize: "12px",
              color: "#666",
              marginTop: "4px",
              textAlign: "right",
            }}
          >
            {this.state.noteRecupero.length}/500 caratteri
          </div>
        </div>
        <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
          <FixButton
            title="Salva"
            disabled={!this.state.selectedLezione || this.state.isSaving}
            callback={() => this.addProposta()}
          />
          <FixButton
            title="Annulla"
            callback={() => {
              this.props.onClose();
            }}
          />
        </div>
      </div>
    );
  }
}

const cardClass = {
  position: "fixed",
  left: "45%",
  top: "20%",
  background: "#ffffff",
  border: "1px solid black",
  padding: "20px",
  overflow: "scroll",
  zIndex: 999,
};

const closeIcon = {
  position: "absolute",
  cursor: "pointer",
  right: 0,
  top: 0,
  padding: 10,
};
